export function bool (val) {
  return val ? 'yes' : 'no'
}
export function date (val) {
  return val ? new Date(val).toDateString() : 'none'
}
export function sentence (val) {
  return val.charAt(0).toUpperCase() + val.substr(1).toLowerCase()
}
export function title (val) {
  return val.replace(/\w\S*/g, sentence)
}
export function metres (val) {
  let num = Number(val)
  if (isNaN(num)) {
    return 'none'
  } else {
    return `${num.toFixed(2)} metres`
  }
}



// WEBPACK FOOTER //
// ./src/filters.js